var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import PaymentService from '../../api/UpperPaymentService';
import _ from 'lodash';
import AddDialog from './AddDialog.vue';
import { toDetail } from "../../helper/util";
import { EBillType } from "../../enum/EBillType";
import { UrlHelper } from "../../helper/UrlWrapper";
import { mapGetters } from "vuex";
import CommonService from "../../api/CommonService";
var PaymentOrder = (function (_super) {
    __extends(PaymentOrder, _super);
    function PaymentOrder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.total = 0;
        _this.listData = [];
        _this.selectRows = [];
        _this.formData = null;
        _this.swiperShow = false;
        _this.imgs = [];
        _this.placeholder = ['输入供应商名称', '输入付款单号'];
        _this.dateTypeList = [
            { name: "提交日期", value: 1 },
            { name: "审核日期", value: 2 },
            { name: "付款日期", value: 3 },
            { name: "废弃日期", value: 4 }
        ];
        _this.statusList = [
            { name: '全部状态', value: -1 },
            { name: '待审核', value: 1 },
            { name: '已审核', value: 2 },
            { name: '已废弃', value: 3 }
        ];
        _this.searchTypes = [
            { name: '供应商', value: 1 },
            { name: '付款单号', value: 2 }
        ];
        _this.payment_type_list = [];
        _this.statusModalVisbile = false;
        _this.currentRow = {};
        return _this;
    }
    PaymentOrder.prototype.created = function () {
        this.service = PaymentService.getInstance();
        this.commonService = CommonService.getInstance();
        this.initFormData();
        this.getPaymentList();
        this.getPaymentTypeList();
        console.log('Root_PageAuth', this.Root_PageAuth);
    };
    PaymentOrder.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 210;
        }, 300);
    };
    PaymentOrder.prototype.statusModalConfirm = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.changeIsTaxTicket({
            order_id: this.currentRow.order_id,
            is_tax_ticket: this.currentRow.is_tax_ticket
        }).then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.data.msg || '修改成功');
            _this.statusModalVisbile = false;
            _this.getPaymentList();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PaymentOrder.prototype.changeStatus = function (row) {
        this.currentRow = row;
        this.statusModalVisbile = true;
    };
    PaymentOrder.prototype.initFormData = function () {
        this.formData = {
            time_type: 1,
            s_time: new Date(Date.now() - 30 * 24 * 3600 * 1000),
            e_time: new Date(),
            order_status: -1,
            keyword_type: 1,
            keyword: "",
            payment_type: '',
        };
    };
    PaymentOrder.prototype.getPaymentTypeList = function () {
        var _this = this;
        this.service.getPaymentType().then(function (res) {
            var DATA = res.data;
            var payment_type_list = Array.isArray(DATA.data) ? DATA.data : [];
            _this.payment_type_list = [{ value: '', name: '全部' }].concat(payment_type_list);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    PaymentOrder.prototype.getPaymentList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        if (!this.formData.s_time || !this.formData.e_time) {
            this.$message.error("\u8BF7\u9009\u62E9" + (!this.formData.s_time ? '开始' : '结束') + "\u65E5\u671F\uFF01");
            return;
        }
        var formData = _.cloneDeep(this.formData);
        formData.s_time = formData.s_time.format('yyyy-MM-dd');
        formData.e_time = formData.e_time.format('yyyy-MM-dd');
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getPaymentList(Object.assign(formData, pager)).then(function (res) {
            if (res.data.success) {
                _this.listData = res.data.data;
                _this.total = res.data.total;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            loadingInstance.close();
        }, function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    PaymentOrder.prototype.pageChange = function (pager) {
        this.getPaymentList(pager);
    };
    PaymentOrder.prototype.search = function () {
        this.getPaymentList();
    };
    PaymentOrder.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    PaymentOrder.prototype.toPaymentDetail = function (order) {
        toDetail(EBillType.Payment, order.order_id, this);
    };
    PaymentOrder.prototype.mulAudit = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择单据！');
            return;
        }
        this.$confirm('审核后将不可修改，是否继续？', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                var ids = _.reduce(_this.selectRows, function (ori, newItem) {
                    return ori += ori ? (',' + newItem.order_id) : newItem.order_id;
                }, '');
                _this.audit({ order_ids: ids });
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PaymentOrder.prototype.auditOne = function (order_id) {
        var _this = this;
        this.$confirm('审核后将不可修改，是否继续？', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            _this.audit({ order_ids: order_id });
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PaymentOrder.prototype.audit = function (params) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.audit(params).then(function (res) {
            loadingInstance.close();
            if (res.data.code == 76) {
                _this.$message.error(res.data.msg);
            }
            else {
                _this.$message.success(res.data.msg);
            }
            _this.getPaymentList();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PaymentOrder.prototype.getSelectIds = function () {
        var orderIds = this.selectRows.map(function (item) { return item.order_id; });
        return orderIds;
    };
    PaymentOrder.prototype.lookDetail = function (row) {
        toDetail(EBillType.UpperPaymentDetail, row.order_id);
    };
    PaymentOrder.prototype.edit = function (order_id) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getUpdateInfo({ order_id: order_id }).then(function (res) {
            if (res.data.success) {
                var instance = _this.$dialog(AddDialog, {
                    data: {
                        supplier_upper_name: res.data.data.supplier_upper_name,
                        payment_money: res.data.data.payment_money,
                        formData: res.data.data,
                    }
                }, {
                    title: "修改付款单",
                    width: 600,
                    height: 520
                }).instance;
                instance.$on('ok', function () {
                    _this.getPaymentList();
                });
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            loadingInstance.close();
        }, function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    PaymentOrder.prototype.mulDelete = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择单据！');
            return;
        }
        this.$confirm('确认废弃后，对应的付款单处于已废弃状态，其中的对账单可以重新被选择生成新的付款单据。', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                var ids = _.reduce(_this.selectRows, function (ori, newItem) {
                    return ori += ori ? (',' + newItem.order_id) : newItem.order_id;
                }, '');
                _this.delete({ order_ids: ids });
            }
        }).catch(function (err) {
        });
    };
    PaymentOrder.prototype.deleteOne = function (order_id) {
        var _this = this;
        this.$confirm('确认废弃后，对应的付款单处于已废弃状态，其中的对账单可以重新被选择生成新的付款单据。', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            _this.delete({ order_ids: order_id });
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PaymentOrder.prototype.delete = function (params) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.delete(params).then(function (res) {
            loadingInstance.close();
            if (res.data.code == 76) {
                _this.$message.error(res.data.msg);
            }
            else {
                _this.$message.success(res.data.msg);
            }
            _this.getPaymentList();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PaymentOrder.prototype.operateCommand = function (command) {
        switch (command) {
            case 1:
                this.mulPrint();
                break;
            case 2:
                this.export();
                break;
            case 3:
                this.mulDelete();
                break;
        }
    };
    PaymentOrder.prototype.export = function () {
        var _this = this;
        var orderIds = this.getSelectIds();
        var url = '/supplierclientapi/upper_payment_order/export?order_ids=' + orderIds.join(",");
        url = UrlHelper.addParam(url, 'token', this.user.token);
        if (!this.formData.s_time || !this.formData.e_time) {
            this.$message.error("\u8BF7\u9009\u62E9" + (!this.formData.s_time ? '开始' : '结束') + "\u65E5\u671F\uFF01");
            return;
        }
        var formData = _.cloneDeep(this.formData);
        formData.s_time = formData.s_time.format('yyyy-MM-dd');
        formData.e_time = formData.e_time.format('yyyy-MM-dd');
        for (var key in formData) {
            formData[key] = (formData[key] === undefined || formData[key] === null) ? '' : formData[key];
            url = UrlHelper.addParam(url, key, formData[key]);
        }
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PaymentOrder.prototype.mulPrint = function () {
        var orderIds = this.getSelectIds();
        if (!orderIds.length) {
            this.$message.error("请先选择单据！");
            return;
        }
        var url = orderIds.length == 1 ?
            "./static/js/print/print.html" :
            "./static/js/print/printbatch.html";
        url = UrlHelper.addParam(url, 'type', "upperPayment");
        url = UrlHelper.addParam(url, 'order_id', orderIds.join(","));
        url = UrlHelper.addParam(url, 'token', this.user.token);
        UrlHelper.windowOpenIntercept(url);
    };
    PaymentOrder = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user"
            }))
        })
    ], PaymentOrder);
    return PaymentOrder;
}(Vue));
export default PaymentOrder;
